module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.configActive
    },
    on: {
      "change": _vm.toggleFilter
    }
  }), _vm._v(" "), (_vm.configActive) ? _c('section', {
    staticClass: "filterConfig"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Filter Type")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.configValues.type
    },
    on: {
      "change": function($event) {
        _vm.updateVuexFilter($event.target.value, 'type')
      }
    }
  }, _vm._l((_vm.options.filter.allTypes), function(type) {
    return _c('option', [_vm._v(_vm._s(type))])
  })), _vm._v(" "), _c('label', [_vm._v("Frequency")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "20000",
      "step": "100"
    },
    domProps: {
      "value": _vm.configValues.frequency
    },
    on: {
      "change": function($event) {
        _vm.updateVuexFilter($event.target.value, 'frequency')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.configValues.frequency
    },
    on: {
      "change": function($event) {
        _vm.updateVuexFilter($event.target.value, 'frequency')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Q")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "30"
    },
    domProps: {
      "value": _vm.configValues.Q
    },
    on: {
      "change": function($event) {
        _vm.updateVuexFilter($event.target.value, 'Q')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.configValues.Q
    },
    on: {
      "change": function($event) {
        _vm.updateVuexFilter($event.target.value, 'Q')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Rolloff")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.configValues.rolloff
    },
    on: {
      "change": function($event) {
        _vm.updateVuexFilter($event.target.value, 'rolloff')
      }
    }
  }, _vm._l((_vm.options.filter.rollOffValues), function(rolloff) {
    return _c('option', [_vm._v(_vm._s(rolloff))])
  }))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Filter")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78917ac5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/filter_config.vue
// module id = 287
// module chunks = 1